export default {
    1: "Annotator",
    2: "Reviewer",
    3: "SuperChecker",
    4: "WorkspaceManager",
    5: "OrganizationOwner",
    6: "Admin"
}